const toNumber = apiString => {
  if (typeof apiString === 'number') return apiString;
  if (!apiString) return 0;
  return parseInt(apiString);
};

export default toNumber;
